import { FC, HTMLAttributes } from "react";
import clsx from "classnames";
import { Typography, TypographyVariant, Image } from "@onmo/ui";
import { Game } from "@onmo/graphql/graphql";
import TopGameIcon from "../../../assets/icons/popular_games_1x.webp";
import TopGameIcon2x from "../../../assets/icons/popular_games_2x.webp";
import TopGameIcon3x from "../../../assets/icons/popular_games_3x.webp";
import { ContinuePlayLoading } from "../PagesLoading/ContinuePlayLoading";
import { useStyles } from "./ContinuePlay.style";
import GamesSection from "../GamesSection/GamesSection";

interface IContinuePlayProps {
  isTopGame?: boolean;
  isPlayAndWin?: boolean;
  label?: string;
  games?: Game[];
  isEndscreen?: boolean;
  onCloseEndscreen?: () => void;
}

export const ContinuePlay: FC<
  IContinuePlayProps & HTMLAttributes<HTMLDivElement>
> = (props) => {
  const classes = useStyles();
  const {
    games,
    isTopGame,
    isPlayAndWin,
    label,
    isEndscreen,
    onCloseEndscreen,
    className,
    ...otherProps
  } = props;

  if (!games)
    return (
      <ContinuePlayLoading
        {...otherProps}
        isTopGame
        className={clsx(classes.root, isTopGame && classes.topRoot, className)}
      />
    );

  if (games.length === 0) return null;

  return (
    <div
      {...otherProps}
      className={clsx(classes.root, isTopGame && classes.topRoot, className)}
    >
      <Typography
        variant={TypographyVariant.HeadingH6Bold}
        className={clsx(
          classes.headerTitle,
          isTopGame && "topGame",
          isPlayAndWin && "playAndWin",
        )}
      >
        {isTopGame && (
          <Image
            src={TopGameIcon}
            src2x={TopGameIcon2x}
            src3x={TopGameIcon3x}
          />
        )}
        {label}
      </Typography>
      <GamesSection
        games={games}
        isTopGame={isTopGame}
        isEndscreen={isEndscreen}
        onCloseEndscreen={onCloseEndscreen}
      />
    </div>
  );
};
